export default __webpack_public_path__ + "static/media/logo01.2fd9cda3.svg";